







































































































































import {
  defineComponent, reactive, onMounted, ref, computed, onUnmounted,
} from '@vue/composition-api';

import useRouter from '@/useRouter';

import { data } from '@/quiz';

const debounce = <F extends (...args: any[]) => any>(
  func: F,
  waitFor: number,
) => {
  let timeout = 0;

  const debounced = (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), waitFor);
  };

  return debounced as any;
};

function shuffle<T>(arr: T[]) {
  return arr.sort(() => 0.5 - Math.random());
}

const MAXIMUM_TRIES = 2;

const Quiz = defineComponent({
  setup() {
    const { router } = useRouter();

    onMounted(() => { window.scrollTo(0, 0); });

    const resultShow = ref(-1);
    const wrong = ref(0);
    const correct = ref(0);

    const cardList: typeof data = reactive([]);
    const cardStack = ref([...shuffle(data.slice(1, data.length)), data[0]]);
    // const cardStack = ref(shuffle(data.slice(24, data.length)));
    const nextCard = computed(() => cardStack.value[cardStack.value.length - 1]);

    const selectedArrowPosition = ref(-1);

    const attemptScroll = ref(false);
    function adjustScroll() {
      if (attemptScroll.value) return;

      const arrows = document.querySelectorAll('.arrow-container');
      const scrollContainer = document.querySelector('#scroll-container');

      if (!scrollContainer) return;

      const scrollContainerWidth = scrollContainer?.getBoundingClientRect().width || 0;
      const arrowDistanceArray = Array.from(arrows)
        .map((elm) => {
          const rect = elm.getBoundingClientRect();
          return rect.left - (scrollContainerWidth / 2) + (rect.width / 2);
        });
      const absArray = arrowDistanceArray.map(Math.abs);
      const absArrayWithoutFirstHiddenArrow = absArray.slice(1, absArray.length);
      const nearestArrowIndex = absArray.indexOf(Math.min(...absArrayWithoutFirstHiddenArrow));
      // console.log('absArray', absArray);
      // console.log('nearestArrowIndex', nearestArrowIndex);

      const arrow = arrows[nearestArrowIndex];
      const arrowRect = arrow.getBoundingClientRect();

      const arrowScrollPosition = scrollContainer.scrollLeft + arrowRect.left + (arrowRect.width / 2);
      const currentScrollPosition = scrollContainer.scrollLeft + (scrollContainerWidth / 2);

      // console.log('arrowScrollPosition', arrowScrollPosition);
      // console.log('currentScrollPosition', currentScrollPosition);

      selectedArrowPosition.value = nearestArrowIndex - 0.5;
      if (Math.abs(currentScrollPosition - arrowScrollPosition) > 5) {
        attemptScroll.value = true;
        // scrollContainer.scrollLeft = arrowScrollPosition - (scrollContainerWidth / 2); // eslint-disable
        scrollContainer.scrollTo({
          left: arrowScrollPosition - (scrollContainerWidth / 2),
          behavior: 'smooth',
        });
        setTimeout(() => { attemptScroll.value = false; }, 200);
      }
    }

    const adjustDebounced = debounce(adjustScroll, 200);

    onMounted(() => {
      // cardList.push(...([...data].splice(0, 24)));
      adjustScroll();
      window.addEventListener('resize', adjustDebounced);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', adjustDebounced);
    });

    function isCorrectPosition() {
      const arrow = selectedArrowPosition.value;
      const insertingOrder = nextCard.value.order;
      const previousCard = cardList[arrow - 0.5] || undefined;
      const afterCard = cardList[arrow + 0.5] || undefined;
      if (previousCard === undefined && afterCard === undefined) return false;
      if (previousCard !== undefined && !(insertingOrder > previousCard.order)) return false;
      if (afterCard !== undefined && !(insertingOrder < afterCard.order)) return false;
      return true;
    }

    function animateInsert(type: number) {
      resultShow.value = type;
      setTimeout(() => { resultShow.value = -1; }, 1000);
    }

    function insertCard() {
      adjustScroll();
      const isCorrect = isCorrectPosition();
      const card = cardStack.value.pop();
      if (!card) return;
      if (!isCorrect) {
        wrong.value += 1;
        let correctPlacement = -1;
        cardList.forEach((elm, i) => {
          if (elm.order < card.order) correctPlacement = i + 1;
        });
        if (correctPlacement === -1) console.log('smthing wrong');
        cardList.splice(correctPlacement, 0, card);
        animateInsert(0);
        setTimeout(() => { adjustScroll(); }, 100); // reset scroll position
      } else if (cardStack.value.length >= 0) {
        correct.value += 1;
        resultShow.value = 1;
        cardList.splice(selectedArrowPosition.value + 0.5, 0, card);
        animateInsert(1);
      }
      if (cardStack.value.length === 0 || wrong.value > MAXIMUM_TRIES) { // stack end condition
        setTimeout(() => {
          router.push({
            name: 'Result',
            params: { score: String(correct.value) },
          });
        }, 1000);
      }
    }

    function initialCardAdd() {
      correct.value += 1;
      const card = cardStack.value.pop();
      if (card) {
        cardList.splice(0, 0, card);
        animateInsert(0);
        setTimeout(() => { adjustScroll(); }, 100); // reset scroll position
      }
    }

    const isDragging = ref(false);
    const initialPointX = ref(0);
    const initialScrollPointX = ref(0);
    function onDragStart(e: MouseEvent) {
      isDragging.value = true;
      initialPointX.value = e.x;
      const scrollContainer = document.querySelector('#scroll-container');
      if (!scrollContainer) return;
      initialScrollPointX.value = scrollContainer.scrollLeft;
    }
    function onDragEnd() {
      attemptScroll.value = false;
      isDragging.value = false;
      adjustScroll();
    }
    function onDragMove(e: MouseEvent) {
      if (!isDragging.value) return;
      const diff = initialPointX.value - e.x;
      attemptScroll.value = true;
      const scrollContainer = document.querySelector('#scroll-container');
      if (!scrollContainer) return;
      scrollContainer.scrollTo({
        left: initialScrollPointX.value + diff,
      });
    }

    const isInitialCard = computed(() => correct.value === 0);

    return {
      isInitialCard,
      initialCardAdd,
      isDragging,
      attemptScroll,
      nextCard,
      onScroll: adjustDebounced,
      selectedArrowPosition,
      cardList,
      insertCard,
      wrong,
      correct,
      resultShow,
      onDragStart,
      onDragEnd,
      onDragMove,
      cardStack,
    };
  },
});

export default Quiz;
